<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<!-- *ngIf="ready" -->
<ng-container>
  <div class="tableTitle">
    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="true" [hasButton]="true"
      [actionsTemplate]="actionsButtons" [hasShowQr]="false" [hasHeaderActions]="true"
      [headerActionsTemplate]="headerActionsButtons" [hasMonthFilter]="true" [remarkField]="'rectifying'"
      [remarkMessage]="'incompleteMessage'" [showTotals]="true" [showTotalsHasOptionToPay]="true"
      [textPaided]="'Cobrado'" [textUnpaid]="'No cobrado'" (invoiceNumberClick)="onInvoiceNumberClick($event)"
      (amountNumberClick)="onAmountNumberClick($event)">

      <div filterBarActions>
        <button mat-stroked-button (click)="irpfCuenta()">
          <mat-icon>assignment</mat-icon> IRPF a cuenta
        </button>
        <button mat-stroked-button (click)="statistics()">
          <mat-icon>show_chart</mat-icon> Estadísticas
        </button>
      </div>

    </app-table>
  </div>

  <ng-container *ngIf="empty">
    <div class="text-center mt-3 fc-grey mb-3">
      <img src="assets/icons/factura.svg" class="invoiceImageInvoice">
      <p>No tiene ninguna factura.</p>
      <p>Recuerde que para crear una factura,
        <strong>primero debe crear un presupuesto</strong>.
      </p>
      <p>Haga click en el siguiente enlace para crear uno:</p>
      <button mat-stroked-button (click)="createPreinvoice()">Crear Presupuesto</button>
    </div>
  </ng-container>
  <ng-container *ngIf="ready && showQrCodeString">
    <app-qr-zoom [src]="qrCodeString" [showZoom]="showQrCodeString" (showZoomEvent)="onShowQr($event)"></app-qr-zoom>
  </ng-container>

  <!--acciones buttons header-->
  <ng-template #headerActionsButtons let-selected="selected">
    <ul class="custom-class">
      <li (click)="bookIssuedInvoices(selected)">
        <a>Libro de facturas emitidas</a>
      </li>
      <li (click)="sepa(selected, 'b2b')">
        <a>Domiciliar B2B</a>
      </li>
      <li (click)="sepa(selected, 'core')">
        <a>Domiciliar Core</a>
      </li>
      <li (click)="excelContabilidad(selected)">
        <a>Excel Contabilidad</a>
      </li>
      <li (click)="excelContabilidadGlobal()">
        <a>Excel Contabilidad Global</a>
      </li>
      <li (click)="excelCobros(selected)">
        <a>Excel de cobros</a>
      </li>
      <li (click)="invoicePaidedSelected(selected)">
        <a>Cobrar facturas</a>
      </li>
      <li (click)="pdfMailMultipleAttach(selected)">
        <a>Enviar PDF</a>
      </li>
    </ul>
  </ng-template>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
      <ul class="custom-class">
        <li (click)="pdf(uid, row.invoiceNumber, row.receiverName, row.isInvoice, row.isDeliveryNote)">
          <a>
            <mat-icon>dvr</mat-icon> PDF
          </a>
        </li>
        <li (click)="showQr(uid)">
          <a>
            <mat-icon>dvr</mat-icon> Código Qr
          </a>
        </li>
        <ng-container *ngIf="row.sendedMail != null">
          <li (click)="pdfMail(uid)">
            <a>
              <mat-icon>send</mat-icon>Enviada {{row.sendedMail | date}}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="row.sendedMail == null">
          <li (click)="pdfMail(uid)">
            <a>
              <mat-icon>send</mat-icon>Enviar PDF
            </a>
          </li>
        </ng-container>
        <li *ngIf="isProjectEnable" (click)="project(uid)">
          <a>
            <mat-icon>edit</mat-icon> Proyecto
          </a>
        </li>


        <ng-container *ngIf="row.paided != null">
          <li (click)="invoicePaided(uid)">
            <a>
              <mat-icon>payment</mat-icon> Cobrada {{row.paided | date}}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="row.paided == null && !row.rectifying ">
          <li (click)="invoicePaided(uid)">
            <a>
              <mat-icon>payment</mat-icon> Añadir cobro<app-help key='Ingresos17'></app-help>
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="!row.rectifying && row.total >= 0">
          <li (click)="rectification(uid)">
            <a>
              <mat-icon>clear</mat-icon> Rectificar
            </a>
          </li>
        </ng-container>
        <li (click)="openContactInvoices(uid)">
          <a>
            <mat-icon>person</mat-icon> Histórico Cliente
          </a>
        </li>
        <li (click)="showMessageVerifactu(uid)">
          <a><mat-icon>info</mat-icon>
            Detalle verifactu</a>
        </li>
        <ng-container *ngIf="!row.rectifying">
          <li (click)="generateFacturae(uid, row.invoiceNumber)">
            <a><mat-icon>fingerprint</mat-icon> Factura
              electrónica</a>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </ng-template>

</ng-container>
